import React, { useState, useRef, useEffect } from "react";
import { Marker, Popup } from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import L from "leaflet";
import { fetchHorairesForAll } from "./Fonctions_Communications_API";
import { PS_Horaires_Ouverture } from "./PS_Horaires_Ouverture";
import "../css/PS_Markers.css";

const PraticienMarkers = ({ praticiensData, coordonnéesPointCentral, afficherClusters }) => {
    const [scrollDownDemanded, setScrollDownDemanded] = useState(false);
    const scrollableDivRef = useRef(null);
    const [horairesData, setHorairesData] = useState({});
    const [infosPraticiens, setInfosPraticiens] = useState(false);
    const [InfosSites, setInfosSites] = useState(false);

    useEffect(() => {
        if (scrollableDivRef.current) {
            scrollableDivRef.current.scrollTo({
                top: scrollableDivRef.current.scrollHeight,
                behavior: "smooth",
            });
        }
    }, [scrollDownDemanded]);

    useEffect(() => {
        const fetchHoraires = async () => {
            if (praticiensData.length > 0) {
                await fetchHorairesForAll(praticiensData, setHorairesData);
            }
        };
        fetchHoraires();
    }, [praticiensData]);

    const groupedByCoordsAndSite = praticiensData.reduce((acc, praticien) => {
        const key = JSON.stringify(praticien.coords);

        if (!acc[key]) {
            acc[key] = {
                coords: praticien.coords,
                adresse: praticien.adresse,
                sites: {},
            };
        }

        const siteKey = praticien.nom_site || "Autre";
        if (!acc[key].sites[siteKey]) {
            acc[key].sites[siteKey] = [];
        }

        acc[key].sites[siteKey].push(praticien);
        return acc;
    }, {});

    const [EtablissementChoisi, setEtablissementChoisi] = useState(null);

    const [praticienChoisi, setPraticienChoisi] = useState(null);

    const [attributs, setAttributs] = useState({});
    useEffect(() => {
        if (praticienChoisi && horairesData[praticienChoisi.rpps_id]) {
            const carte_vitale = horairesData[praticienChoisi.rpps_id][0].sesam_vitale;
            const convention = horairesData[praticienChoisi.rpps_id][0].convention;
            setAttributs({ vitale: carte_vitale, conv: convention });
        } else {
            setAttributs({ vitale: "Non renseigné", conv: "Non renseigné" });
        }
    }, [praticienChoisi, horairesData]);


    const listRef = useRef(null);

    const markers = Object.entries(groupedByCoordsAndSite).map(([coordsKey, data]) => {
        const [lat, lng] = data.coords;

        return (
            <Marker
            key={coordsKey}
            position={[lat, lng]}
            eventHandlers={{
                click: () => {
                    setInfosSites(false);
                    setInfosPraticiens(false);
                }
            }}
            icon={new L.Icon({
                iconUrl: `logos_marianne_PS/${Object.values(data.sites)[0][0].profession}.png`,
                iconSize: [40, 40],
                iconAnchor: [20, 40],
                popupAnchor: [0, -30],
                shadowUrl: "marker_shadow.png",
                shadowSize: [41, 41],
            })}
        >
            <Popup closeOnClick={false}>
                <div className="popup-content-praticiens" ref={scrollableDivRef}>
                    {!InfosSites ? (
                        
                        <div>
                            <div className="popup-title-header" style={{marginBottom:'3%', fontSize: '1.1rem'}}>
                                <p className="popup-title-praticiens">{data.adresse.length > 45 ? data.adresse.slice(0, 45) + "..." : data.adresse}</p>
                            </div>
                            <div
                                className="praticiens-list"
                                style={{ maxHeight: "210px", overflowY: "auto" }}
                                onScroll={(e) => {
                                    const container = e.target;
                                    const children = container.querySelectorAll('.praticiens-card');
                                    const containerHeight = container.clientHeight;
                                    const scrollTop = container.scrollTop;

                                    children.forEach((child) => {
                                    const childTop = child.offsetTop - scrollTop;
                                    const distanceFromCenter = Math.abs(childTop - containerHeight/0.9  + child.clientHeight / 2);
                                    const fadeLevel = Math.min(1, distanceFromCenter / 200); 

                                    
                                    child.style.opacity = 1 - fadeLevel;
                                    child.style.transform = `scale(${1 - fadeLevel * 0.2})`; 
                                    child.style.filter = `brightness(${1 - fadeLevel * 0.3})`; 
                                    });
                                }}
                                >
                                {Object.keys(data.sites).map((siteName, index) => (
                                    <button 
                                    key={index} 
                                    className="praticiens-card" 
                                    onClick={() => { 
                                        setEtablissementChoisi(data.sites[siteName]); 
                                        setInfosSites(true);
                                    }}
                                    >
                                    <div className="praticiens-info">
                                        <strong>{siteName}</strong>
                                        <span className="praticiens-profession">{data.sites[siteName].length} praticien{data.sites[siteName].length > 1 ? "s" : ""}</span>
                                    </div>
                                    </button>
                                ))}
                                </div>

                            <div className="popup-bouton-div-praticiens" style={{justifyContent:'end'}}>
                                
                            <button
                            className="popup-button-praticiens"
                            
                            onClick={() => {
                                const destination = `${lat},${lng}`;
                                const openStreetMapUrl = `https://www.openstreetmap.org/directions?engine=fossgis_osrm_car&route=${coordonnéesPointCentral.lat},${coordonnéesPointCentral.lng};${destination}`;
                                window.open(openStreetMapUrl, "_blank");
                            }}
                        >
                            <img src="itineraires_blanc.png" alt="Go" className="popup-button-praticiens-image" />
                        </button>
                        </div>
                        </div>
                    ) : 
                    ((InfosSites && !infosPraticiens) ? (
                        <div>
                            <div className="popup-title-header" style={{marginBottom:'3%'}}>
                                
                                <p className="popup-title">{(EtablissementChoisi?.[0]?.nom_site.length>45 ? EtablissementChoisi?.[0]?.nom_site.slice(0, 45)+ "..." : EtablissementChoisi?.[0]?.nom_site )|| "Cet établissement"}</p>
                            </div>

                            <div className="praticiens-list"
                            onScroll={(e) => {
                                const container = e.target;
                                const children = container.querySelectorAll('.praticiens-card');
                                const containerHeight = container.clientHeight;
                                const scrollTop = container.scrollTop;

                                children.forEach((child) => {
                                const childTop = child.offsetTop - scrollTop;
                                const distanceFromCenter = Math.abs(childTop - containerHeight  + child.clientHeight / 2);
                                const fadeLevel = Math.min(1, distanceFromCenter / 200); 

                                
                                child.style.opacity = 1 - fadeLevel;
                                child.style.transform = `scale(${1 - fadeLevel * 0.2})`; 
                                child.style.filter = `brightness(${1 - fadeLevel * 0.3})`; 
                                });
                            }}>
                                {EtablissementChoisi?.map((praticien) => ( 
                                    <button 
                                        key={praticien.rpps_id} 
                                        className="praticiens-card" 
                                        onClick={() => { 
                                            setPraticienChoisi(praticien);
                                            setInfosPraticiens(true);
                                        }}
                                    >
                                        <div className="praticiens-info">
                                            <strong>{praticien.prenom} {praticien.nom}</strong>
                                            <span className="praticiens-profession">{praticien.profession}</span>
                                        </div>
                                    </button>
                                ))}
                            </div>
                            <div className="popup-bouton-div-praticiens" >
                            <button
                                    type="button"
                                    className="popup-button-praticiens"
                                    onClick={() => setInfosSites(false)}
                                >
                                    <span style={{ color: "white" }}>←</span>
                                </button>
                            <button
                            className="popup-button-praticiens"
                            
                            onClick={() => {
                                const destination = `${lat},${lng}`;
                                const openStreetMapUrl = `https://www.openstreetmap.org/directions?engine=fossgis_osrm_car&route=${coordonnéesPointCentral.lat},${coordonnéesPointCentral.lng};${destination}`;
                                window.open(openStreetMapUrl, "_blank");
                            }}
                        >
                            <img src="itineraires_blanc.png" alt="Go" className="popup-button-praticiens-image" />
                        </button>
                        </div>
                        </div>
                    ) : (
                        <div className="popup-content-praticiens">
                                <div className="popup-title-header" style={{marginBottom:'3%', flexDirection:'row'}}>
                                

                                <h2 className="popup-title">{praticienChoisi.prenom} {praticienChoisi.nom}</h2>
                                </div>
                                <div style={{ maxHeight: '260px', overflow: 'auto', scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
                                <p><strong>{praticienChoisi.nom_site}</strong></p>
                                <p  className="popup-label">
                                <img src="specialite.png" alt="Spe" className="popup-icon" title="Spécialité"/>
                                    {praticienChoisi.profession}

                                </p>
                                <p className="popup-label">
                                <img src="adresse.png" alt="Adresse" className="popup-icon" title="Adresse"/>
                                {praticienChoisi.adresse}
                                </p>
                                <p className="popup-label">
                                    <img src="carte-vitale.png" alt="Carte Vitale" className="popup-icon" style={{borderRadius:'2px'}} title="Carte vitale"/>
                                    {attributs.vitale==="O" ? "Ce praticien accepte la carte vitale" : (attributs.vitale==="N" ? "Ce praticien n'accepte pas la carte vitale" : "Non renseigné")}
                                </p>
                                <p className="popup-label">
                                <img src="convention.png" alt="Convention" className="popup-icon" title="Conventionné"/>
                                    {attributs.conv==="c1" ? "Conventionné secteur 1" : (attributs.conv==="c2" ? "Conventionné secteur 1 avec droit au dépassement"  :(attributs.conv==="c3" ? "Conventionné secteur 2": "Non renseigné"))}
                                </p>

                                {horairesData[praticienChoisi.rpps_id] ? (
                                    <PS_Horaires_Ouverture
                                        praticien={praticienChoisi}
                                        horaires={horairesData[praticienChoisi.rpps_id]}
                                        scrollDownDemanded={scrollDownDemanded}
                                        setScrollDownDemanded={setScrollDownDemanded}
                                    />
                                ):(
                                    <p className="popup-label"><i>Horaires non renseignés</i></p>
                                )}
                                </div>
                                <div className="popup-bouton-div-praticiens" style={{marginTop:horairesData[praticienChoisi.rpps_id] ? '0%' : '4%'}}>
                                    <button
                                        type="button"
                                        className="popup-button-praticiens"
                                        onClick={() => setInfosPraticiens(false)}
                                    >
                                        <span style={{ right: "90%", color: "white" }}>←</span>
                                    </button>
                                    <button
                                        className="popup-button-praticiens"
                                        onClick={() => {
                                            const destination = `${lat},${lng}`;
                                            const openStreetMapUrl = `https://www.openstreetmap.org/directions?engine=fossgis_osrm_car&route=${coordonnéesPointCentral.lat},${coordonnéesPointCentral.lng};${destination}`;
                                            window.open(openStreetMapUrl, "_blank");
                                        }}
                                    >
                                        <img src="itineraires_blanc.png" alt="Go" className="popup-button-praticiens-image" />
                                    </button>
                                </div>
                            </div>
                    ))}
                </div>
            </Popup>
        </Marker>
        );
    });

    return afficherClusters ? <MarkerClusterGroup>{markers}</MarkerClusterGroup> : <>{markers}</>;
};

export default PraticienMarkers;
